import type { TResetPasswordElement } from '@shared/dream-components';
import { ResetPasswordElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

import ResetPasswordAction from '~/components/ResetPasswordAction';

interface Props {
  node: TResetPasswordElement;
  children: ReactNode | ReactNode[];
}

const ResetPassword = ({ node, children }: Props) => {
  return (
    <ResetPasswordAction>
      {({ isLoading }) => (
        <ResetPasswordElement element={node} isSubmitting={isLoading}>
          {children}
        </ResetPasswordElement>
      )}
    </ResetPasswordAction>
  );
};

export default ResetPassword;
